// import React from "react";
// import { NoInternet } from "@utils/defaultImages";
// import BackImg from "@assets/images/stepsBack.jpg";
// import { useTranslation } from "react-i18next";

// const NoInternetConnection = () => {
//   const { t } = useTranslation();
//   return (
//     <div
//       className="p-[20px] md:p-[100px] grid grid-cols-1 md:grid-cols-2 bg-cover rounded-xl"
//       style={{ backgroundImage: `url(${BackImg})` }}
//     >
//       <div className="text-white flex flex-col justify-center">
//         <h2 className="text-[20px] font-[600] font-[Lato]">{t("Oops")}</h2>
//         <p className="text-[16px] font-[Lato] font-[500]">
//           {t("optimizing things")}
//         </p>
//       </div>
//       <div className="text-white flex justify-center mt-3">
//         {" "}
//         <NoInternet className="max-h-[376px] max-w-[265px]" />
//       </div>
//     </div>
//   );
// };

// export default NoInternetConnection;

import React, { useEffect } from "react";
import { NoInternet, Retry } from "@utils/defaultImages";
import BackImg from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useNetworkStatus from "@hooks/useNetworkStatus"; // Adjust path as needed

const NoInternetConnection = () => {
  const { t } = useTranslation();
  const isOnline = useNetworkStatus();
  const { state } = useLocation();

  // If reason is 'server_error', we disable auto-redirect to prevent infinite loops
  const isServerError = state?.reason === "server_error";

  const handleRetry = () => {
    const savedLocation = localStorage.getItem("lastLocation") || "/";
    localStorage.removeItem("lastLocation");

    // Using replace to refresh the app state and go back
    window.location.replace(savedLocation);
  };

  // Logic: Auto-comeback ONLY if internet was lost and is now restored.
  // We skip this if it was a server error (isOnline is true but server is down).
  useEffect(() => {
    if (isOnline && !isServerError) {
      handleRetry();
    }
  }, [isOnline, isServerError]);

  // Clean up storage when component unmounts
  useEffect(() => {
    return () => {
      localStorage.removeItem("lastLocation");
    };
  }, []);

  return (
    <div
      className="p-[20px] md:p-[100px] grid grid-cols-1 md:grid-cols-2 bg-cover rounded-xl"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="text-white flex flex-col justify-center">
        <h2 className="text-[20px] font-[600] font-[Lato]">{t("Oops")}</h2>
        <p className="text-[16px] font-[Lato] font-[500] mb-4">
          {t("optimizing things")}
        </p>

        {/* Retry Button - Always visible */}
        <button
          onClick={handleRetry}
          className="flex items-center gap-2 bg-[#64DDFF] text-white py-2 px-6 rounded-full font-[400] font-[Lato] text-[16px] w-[fit-content]"
        >
          <Retry/>
          {t("Retry")}
        </button>
      </div>

      <div className="text-white flex justify-center mt-3">
        <NoInternet className="max-h-[376px] max-w-[265px]" />
      </div>
    </div>
  );
};

export default NoInternetConnection;
